import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: "100%",
      overflow: "hidden",
    },
    header: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(3),
    },
    headerWrapper: {
      height: "100px",
    },
    tabsWrapper: {
      borderBottom: "1px solid #e8e8e8",
      // borderTop: "1px solid #e8e8e8"
    },
    actionItem: {
      marginLeft: 8,
    },
    tabsPanelWrapper: {
      height: "calc(100vh - 160px)",
    },
  }),
  {
    name: "business-tab-panel-styles",
    flip: null,
  }
);

export default useStyles;
